import React from 'react';
import classNames from 'classnames';
import createReactClass from 'create-react-class';
import HfReactHelper from 'common/utils/hf-react-helper';
import CheckMark from './pricing-levels/checkmark';

const PRO_PRO_BUNDLE_DBX_PLAN_FEATURE_TYPE = 'dbx_plan_feature';

const PricingLevelFeature = createReactClass({
  render() {
    const containerClasses = classNames({
      'm-pricing-level--feature': true,
      'bgi-dropbox-blue': this.props.type === PRO_PRO_BUNDLE_DBX_PLAN_FEATURE_TYPE,
      'pro-pro-bundle--pricing-level--feature': this.props.type === PRO_PRO_BUNDLE_DBX_PLAN_FEATURE_TYPE,
      'small-12': true,
      columns: true,
      block: true,
      expanded: this.props.expanded,
      'main-feature': this.props.key === 'main-feature',
    });

    let primaryColor = 'c-cerulean';
    let trueColor = '#00B3E6';

    if (HfReactHelper.isHelloFax()) {
      primaryColor = 'c-goldenrod';
      trueColor = '#F59600';
    }

    const numberClasses = classNames({
      number: true,
      [primaryColor]: true,
      bold: true,
    });

    const nameClasses = 'name bold';

    const name = (
      <div className={nameClasses}>
        {this.props.name}
        {this.props.sup ? (
          <sup
            style={{
              fontSize: '9px',
            }}
          >
            †
          </sup>
        ) : (
          <></>
        )}
      </div>
    );
    const number = !this.props.number && this.props.number !== 0 ? (
      <></>
    ) : (
      <div className={numberClasses}>{this.props.number}</div>
    );
    const detail = <div className='detail'>{this.props.detail}</div>;
    const check = (
      <div className='number'>
        <CheckMark color={trueColor} />
      </div>
    );

    // Add a check mark if you have a feature with a detail but no no name or number
    //  and this isn't the detail for the looking for more? section
    //  (as denoted by removeCheckMark = true)
    let hasCheckMark = false;
    if (
      !this.props.detail
      && (!this.props.number && this.props.number !== 0)
      && this.props.name
      && !this.props.removeCheckMark
      && this.props.type !== PRO_PRO_BUNDLE_DBX_PLAN_FEATURE_TYPE
    ) {
      hasCheckMark = true;
    }

    return (
      <div className={containerClasses}>
        {number}
        {hasCheckMark && check}
        {name}
        {detail}
      </div>
    );
  },
});

export default PricingLevelFeature;
